import { Container } from "react-bootstrap";
import styles from "./sectionCard.module.css";

export const SectionCard = ({ children, bgColor }) => {
  const cardStyle = (color) => {
    return {
      backgroundColor: color
    }
  };

  return (
    <Container className={styles.card} style={cardStyle(bgColor)}>
      { children }
    </Container>
  )
}
